export const PRICE_RANGE_CONFIG = {
    MIN: 0,
    MAX: 6000,
    STEP: 50,
    UNIT: 'zł',
} as const;
